import React from "react";

/**
 * Мастерская — спецпроект «Волшебная Мастерская» от MAX.D.
 *
 * Максим 22.08.2026: страница о том, как принять участие в создании
 * волшебных миров. Содержания пока нет — есть только замысел, поэтому
 * страница честно говорит, что это и что появится.
 */
const WorkshopPage = () => (
  <div className="fw-page">
    <h1 className="fw-title">Мастерская</h1>
    <p className="fw-sub">
      Волшебная Мастерская от MAX.D — как принять участие в создании миров
      «Волшебного мира».
    </p>

    <section className="fw-card fw-empty">
      <b>Раздел готовится</b>
      <p>
        Здесь будет описание спецпроекта: что такое Мастерская, кто может
        участвовать и с чего начать.
      </p>
    </section>
  </div>
);

export default WorkshopPage;
